import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export type KontaktThema = 'allgemein' | 'presse' | 'kooperation' | 'sonstiges';

export interface KontaktAnfrageSubmission {
  thema: KontaktThema;
  name: string;
  email: string;
  anliegen: string;
  consentDataPrivacy: boolean;
  honeypot: string;
}

export interface KontaktAnfrageResponse {
  ticketId: string;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class KontaktService {
  private readonly http = inject(HttpClient);

  async createAnfrage(input: KontaktAnfrageSubmission): Promise<KontaktAnfrageResponse> {
    return firstValueFrom(
      this.http.post<KontaktAnfrageResponse>('/api/kontakt', {
        thema: input.thema,
        name: input.name,
        email: input.email,
        anliegen: input.anliegen,
        consentDataPrivacy: input.consentDataPrivacy,
        honeypot: input.honeypot,
      }),
    );
  }
}
